//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    submit() {
      this.$emit('onsubmit')
    },
    cancle() {
      this.$emit('popup-close')
    },
  },
}
